import { useContext } from 'react';
import { LabelsContext } from './LabelsProvider';

export function useLabelsContext() {
  const context = useContext(LabelsContext);

  if (!context) {
    throw new Error(
      'The Labels Context must be used within an LabelsContextProvider',
    );
  }

  return context;
}
